// extracted by mini-css-extract-plugin
export default {"container":"ItemInfo_container_GvvSb","files":"ItemInfo_files_EC1fj"};